import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { useLang } from '../lib/lang';
import { IMAGES } from '../content/constants';
import { Page, HeroShell, Reveal } from '../components/motion';
import { CTASection, PageSection, PartnerLogo } from '../components/blocks';

export default function Partners() {
  const { t, link } = useLang();
  const c = t.partners;
  return (
    <Page meta={{ ...t.meta.partners, lang: t.lang }}>
      <HeroShell testId="partners-hero" overline={c.hero.overline} lines={c.hero.lines} sub={c.hero.sub} image={IMAGES.solar} />

      <PageSection overline={c.overline} testId="partners-list">
        <div className="border-t border-white/10">
          {c.items.map((p, i) => {
            const pslug = p.name.toLowerCase().replace(/\s+/g, '-');
            return (
            <Reveal key={p.name} delay={i * 0.05}>
              <Link
                to={link('partner', undefined, pslug)}
                data-testid={`partner-row-${pslug}`}
                className="group grid md:grid-cols-12 gap-4 md:gap-6 py-10 md:py-12 border-b border-white/10 items-center hover:bg-surface/60 transition-colors duration-500 md:px-4"
              >
                <span className="md:col-span-1 font-mono text-xs text-volt tracking-[0.2em] self-start md:self-center">0{i + 1}</span>
                <div className="md:col-span-2">
                  <PartnerLogo slug={pslug} name={p.name} className="w-full max-w-[150px] aspect-[3/2] rounded" />
                </div>
                <h2 className="md:col-span-3 font-display text-2xl md:text-4xl font-black uppercase tracking-tighter text-white group-hover:text-volt transition-colors duration-500">
                  {p.name}
                </h2>
                <p className="md:col-span-2 font-mono text-[10px] uppercase tracking-[0.2em] text-volt leading-relaxed">{p.tag}</p>
                <p className="md:col-span-3 text-sm text-zinc-400 leading-relaxed">{p.d}</p>
                <span className="md:col-span-1 hidden md:flex justify-end">
                  <ArrowUpRight className="w-6 h-6 text-zinc-600 group-hover:text-volt group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-500" />
                </span>
              </Link>
            </Reveal>
            );
          })}
        </div>
      </PageSection>

      <CTASection title={c.cta} btn={c.cta} />
    </Page>
  );
}
